import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { type TransferRequestUpdateStatusRequest, type TransferRequestResponse, TransferRequestsApi, RestApiError, ErrorCode } from '@shared/api';

const ERROR_CODES = [ErrorCode.TRP_VAL_008, ErrorCode.TRP_VAL_009, ErrorCode.TRP_VAL_010, ErrorCode.TRP_VAL_011];

const updateStatusEffect = createEffect((request: TransferRequestUpdateStatusRequest) => TransferRequestsApi.updateStatus(request));
const clearEvent = createEvent();

const $dataStore = createStore<TransferRequestResponse | null>(null)
  .on(updateStatusEffect.done, (_, values) => values.result.data || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(updateStatusEffect.pending, (_, data) => data)
  .on(updateStatusEffect.fail, () => false)
  .on(updateStatusEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<{ message: string; errorCode?: ErrorCode } | null>(null)
  // .on(updateStatusEffect, () => null)
  .on(updateStatusEffect.fail, (_, data) => {
    if (data.error.message === 'Invalid code, try again') return null;
    if (RestApiError.isRestApiError(data.error) && data.error.data.errorCode) {
      if (ERROR_CODES.includes(data.error.data.errorCode)) return { errorCode: data.error.data.errorCode, message: data.error.data.message };
      return { message: data.error.message };
    }
    return { message: 'Something went wrong while updating Status. Please try again.' };
  })
  .on(updateStatusEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error?.errorCode ? null : error?.message));

export const $transferUpdateStatusStore = {
  events: {
    updateStatus: updateStatusEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
